import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiEndpoints } from '@core/constants';
import { SearchBuilderResponse } from '@core/models';
import { Observable, of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import Helper from '@shared/utils/Helper';
import { SessionSecurityService } from '@shared/services';

@Injectable({
  providedIn: 'root'
})
export class SearchQueryBuilderService {
  apiUrl: string;
  constructor(private http: HttpClient, private sessionSecurity: SessionSecurityService) { }

  getSearchBuilderParam(screen): Observable<SearchBuilderResponse[]> {

    let userId: string = this.sessionSecurity.getObject('UserId');

    let localStorageName = userId + ((screen === 'memberSearch') ? "-SearchBuilderParams-MemberSearch" : "-SearchBuilderParams-ApprovalQueue");


    let searchBuilderParams = this.sessionSecurity.getObjectLocalStorage<SearchBuilderResponse[]>(localStorageName);

    if (Helper.isNullOrEmpty(searchBuilderParams)) {
      if (screen === 'memberSearch') {
        this.apiUrl = ApiEndpoints.searchBuilderParamsForMemberSearch;
      } else {
        this.apiUrl = ApiEndpoints.searchBuilderParamsForApprovalQueue;
      }

      return this.http.get<SearchBuilderResponse[]>(this.apiUrl).pipe(
        map((res) => {
          if (Helper.hasAny(res)) {
            this.sessionSecurity.setObjectLocalStorage<SearchBuilderResponse[]>(
              res,
              localStorageName
            );
          }
          return res;
        }),
        catchError(
          this.handleError<SearchBuilderResponse[]>('getSearchBuilderParam', [])
        )
      );
    }
    else {
      return new Observable((observer) => {
        setTimeout(() => {
          observer.next(searchBuilderParams);
        }, 300);
      });
    }
    
  }

  /**
   * Handle Http operation that failed.
   * Let the app continue.
   * @param operation - name of the operation that failed
   * @param result - optional value to return as the observable result
   */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      console.error(error); // log to console instead
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

}
